// @ts-nocheck
import { get, post, put, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * Busca regiões
 */
export const getRegioes = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/regioes?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca estados/UFs
 */
export const getEstados = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/estados?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca cidades
 */
export const getCidades = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/cidades?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca tipos de veículo
 */
export const getTiposVeiculo = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/tipo-veiculo?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca segmentos de veículo
 */
export const getSegmentosVeiculo = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/segmento-veiculo?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca motoristas
 */
export const getMotoristas = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/motoristas?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca motorista por ID
 */
export const getMotoristaById = async (id) => {
    const url = `${API_URL}/motoristas/${id}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Cria novo motorista
 */
export const createMotorista = async (data) => {
    const url = `${API_URL}/motoristas`;
    const response = await post(url, data);
    return response?.data || response || {};
};
/**
 * Atualiza motorista
 */
export const updateMotorista = async (id, data) => {
    const url = `${API_URL}/motoristas/${id}`;
    const response = await put(url, data);
    return response?.data || response || {};
};
/**
 * Deleta motorista
 */
export const deleteMotorista = async (id) => {
    const url = `${API_URL}/motoristas/${id}`;
    const response = await deleteRequest(url);
    return response?.data || response || {};
};
/**
 * Busca clientes
 */
export const getClientes = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/clientes?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca tipos de carga
 */
export const getTiposCarga = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/tipo-carga?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
